import React from "react";

const MyGap = ({ width, height }) => {
  return <div style={{ width, height }} />;
};

export default MyGap;
